import { findMatchesInSelector, injectClientHighlightSpans } from "./helpers";

export const CommonRules = [
  {
    id: "commonWhitespace",
    name: "Normalise Whitespace",
    description: "Detects multiple consecutive spaces and normalises to one.",
    doc: "### Whitespace Normalisation\nEnsures that copyedited text does not contain double or multiple spaces. It scans text elements and collapses multiple whitespace characters down to a single space.",
    category: "General",
    execute(editor) {
      /* Rule Logic: Scan all paragraph and text blocks for two or more spaces. */
      const pattern = /\s{2,}/g;
      const matches = findMatchesInSelector(editor, "body1, p, abstract, title1", "commonWhitespace", pattern, "Whitespace Normalisation", () => " ");
      injectClientHighlightSpans(editor, matches, "highlight-whitespace");
      return matches;
    }
  },
  {
    id: "commonNumericRanges",
    name: "En-Dashes in Numerical Ranges",
    description: "Converts hyphens to en-dashes in numeric ranges (e.g. years 2020–2022, pages 12–15).",
    doc: "### Numerical Range En-dash\nScholarly style guides mandate the use of en-dashes (–) instead of hyphens (-) for ranges of numbers (such as page ranges, calendar years, or quantitative bounds).",
    category: "General",
    execute(editor) {
      /* Rule Logic: Look for digit-hyphen-digit ranges in body and abstracts. */
      const pattern = /\b(\d+)-(\d+)\b/g;
      const matches = findMatchesInSelector(editor, "body1, p, abstract, .article-body", "commonNumericRanges", pattern, "Numerical Range En-dash", (m) => {
        return `${m[1]}–${m[2]}`;
      });
      injectClientHighlightSpans(editor, matches, "highlight-numeric-range");
      return matches;
    }
  }
];
